import styled from 'styled-components'
import {
  CORRECT,
  FAULTY,
  WARNING,
  UNDEFINED,
} from '@/constants/widgetsDashboard'

export const Container = styled.div`
  position: relative;
  width: 290px;
  height: 212px;
  display: flex;
  box-shadow: 2px 3px 15px ${({ theme }) => theme.colors.shadows.widgetPrimary};
  background: ${({ theme }) => theme.colors.backgrounds.drawer};
  padding: 15px;
  flex-direction: column;
  border-radius: 4px;
  margin-bottom: 10px;
`

export const Header = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`

export const Title = styled.div`
  font-weight: 500;
  letter-spacing: 0.01em;
  font-size: 1.4rem;
  line-height: 1.6rem;
  text-align: left;
  ${({ subtitle, theme }) => subtitle && `
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: ${theme.colors.colors.dim};
  `};
  ${({ rowTitle }) => rowTitle && `
    font-size: 1.2rem;
    line-height: 1.4rem;
    margin-left: 10px;
  `};
`

export const RowContainer = styled.div`
  padding: 10px;
  background: #F4F4F4;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.backgrounds.redisign.table.dark};
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  ${({ id }) => id === UNDEFINED && `
    margin-bottom: 0px;
  `};
`

export const RowTitle = styled.div`
  display: flex;
  align-items: center;
`

export const Indicator = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  ${({ id, theme }) => {
    switch (id) {
      case CORRECT: {
        return `background: ${theme.colors.backgrounds.redisign.green};`
      }
      case FAULTY: {
        return `background: ${theme.colors.backgrounds.redisign.error};`
      }
      case WARNING: {
        return `background: ${theme.colors.backgrounds.redisign.warning};`
      }
      default: {
        return `background: ${theme.colors.backgrounds.redisign.disabled};`
      }
    }
  }};
`
export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
